module.exports = __webpack_public_path__ + "static/media/Teaching.c495c2b3.pdf";